module.exports = __webpack_public_path__ + "img/LinkedIn.ee7e75b3.png";